import React, { useEffect, useState } from 'react'
import { Step, Stepper } from 'react-form-stepper'
import { FormProvider, useForm } from 'react-hook-form'
import InputDataConfiguration from './stepFirst'
import UIFeatureConfiguration from './StepSecond'
import { getInventoryConfigData, postInventoryConfigData } from 'services/inventoryConfigurationService'
import { handleLoader } from 'redux/counterSlice'
import { useDispatch } from 'react-redux'
import { toast, ToastContent } from 'react-toastify'

const defaultStyle = {
  activeBgColor: '#ed1d24',
  activeTextColor: 'transparent',
  completedBgColor: '#a10308',
  completedTextColor: '#ffffff',
  inactiveBgColor: '#C8C8C8',
  inactiveTextColor: 'transparent',
  size: '16px',
  circleFontSize: '0',
  labelFontSize: '0.875rem',
  borderRadius: '50%',
  fontWeight: 500
}

interface InventConfigData{
  admin_db_config: any
  admin_ui_config: any
}

const InventoryForecastConfiguration = () => {
  const [goSteps, setGoSteps] = useState(0);
  const methods = useForm()
  const dispatch = useDispatch()
  const [inventConfigData, setInventConfigData] = useState<InventConfigData>()
  const handleSteps = (steps: number) => {
if(inventConfigData?.admin_db_config && inventConfigData.admin_ui_config){
  switch (steps) {
    case 0:
      return <InputDataConfiguration methods={methods} handleNext={() => setGoSteps(1)} admin_db_config={inventConfigData?.admin_db_config} />
    case 1:
      return <UIFeatureConfiguration handlePrev={() => setGoSteps(0)} methods={methods} admin_ui_config={inventConfigData?.admin_ui_config}/>

  }
}
   

  }

  const onSubmit = async () => {
    const isValid = await methods.trigger();
    if (isValid) {


      const FirstFormData = {
        client_env: localStorage.getItem("clientName") as string,
        ...methods.getValues(),
        dbconf_objectid: inventConfigData?.admin_db_config._id || "",
        objectid:  inventConfigData?.admin_ui_config._id || ""
      }
      
      dispatch(handleLoader(true))
      postConfigPayload(FirstFormData)

    }


  }



  const postConfigPayload = async (FirstformData: any) => {

    try {

      const { result, error } = await postInventoryConfigData(FirstformData)
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }

      dispatch(handleLoader(false))
      toast.success(result.message, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error as ToastContent<unknown>, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }

  }

useEffect(()=>{

  getConfigData()

}, [])


  const getConfigData = async () => {

    try {
      dispatch(handleLoader(true))
      const { result, error } = await getInventoryConfigData()
      if (error) {
        throw error
      }

      setInventConfigData(result)
      dispatch(handleLoader(false))
    } catch (error: any) {
      dispatch(handleLoader(false))
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  }





  return (
    <div className="p-4 content-wrapper configuration-section">
      <div className="card">
        <h4 className="admin-heading">Inventory Configuration</h4>
        <FormProvider {...methods} >
          <form onSubmit={methods.handleSubmit(onSubmit, (err) => { console.log("onSubmit", err) })}>
            <Stepper activeStep={goSteps} styleConfig={{ ...defaultStyle, activeBgColor: "#5627D9", completedBgColor: "#5627D9" }}  >
              <Step key="input-data-configuration" type="button" onClick={() => setGoSteps(0)} label="Step 1"><span className="extra-info">Input Data Configuration</span></Step>
              <Step key="ui-feature-configuration" type="button" onClick={() => setGoSteps(1)} label="Step 2"><span className="extra-info">UI Feature Configuration</span></Step>
            </Stepper>
            {handleSteps(goSteps)}
          </form>
        </FormProvider>
      </div>
    </div >
  )
}

export default InventoryForecastConfiguration


